export const PR_V2_TOOLTIP_TEXT_CLASSNAME = 'text-sm leading-relaxed text-zinc-300';
